export default "__VITE_ASSET__CnjdEDmC__"